import { render } from "./text-strikethrough.vue?vue&type=template&id=f6ed94ae&scoped=true"
const script = {}

import "./text-strikethrough.vue?vue&type=style&index=0&id=f6ed94ae&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6ed94ae"],['__file',"src/views/other/cssfx/components/text-strikethrough.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f6ed94ae"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f6ed94ae', __exports__)) {
    console.log('reload')
    api.reload('f6ed94ae', __exports__)
  }
  
  module.hot.accept("./text-strikethrough.vue?vue&type=template&id=f6ed94ae&scoped=true", () => {
    console.log('re-render')
    api.rerender('f6ed94ae', render)
  })

}


export default __exports__